<template>
    <router-link
        class="competence-link"
        :to="to"
    >
        <div
            class="competence-icon"
            :class="competenceType === 'soft' ? 'soft-icon' : 'hard-icon'"
        >
        </div>
        <div class="competence-name">{{ name }}</div>
    </router-link>
</template>

<script>
const linksPathName = {
    soft: 'other-skills',
    hard: 'hard-skills',
};

export default {
    name: 'CompetenceLink',

    props: {
        cid: [String, Number],
        name: String,
        mode: String,
        competenceType: {
            type: String,
            default: '',
        },
    },

    computed: {
        to() {
            return this.mode
                ?  `/portal/${ linksPathName[this.mode] }/${this.cid}`
                : `${ this.$route.path }/${ this.cid }`;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../styles/rem';
    @import '../../styles/mrem';

    .competence-link {
        display: flex;
        align-items: flex-start;

        &:hover .competence-icon {
            background-image: url("~@/assets/images/icons/hover-competence.svg");
        }

        &:hover .competence-name {
            color: #4663AB;
        }
    }

    .competence-icon {
        width: rem(22);
        height: rem(22);
        flex: none;
        background: no-repeat center/contain;

        @include on-mobile {
            width: mrem(22);
            height: mrem(22);
        }
    }

    .soft-icon {
        background-image: url("~@/assets/images/icons/soft-competence.svg");
    }

    .hard-icon {
        background-image: url("~@/assets/images/icons/hard-competence.svg");
    }

    .competence-name {
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #2A2626;
        margin-left: rem(8);

        @include on-mobile {
            font-size: mrem(18);
            line-height: mrem(26);
            margin-left: mrem(8);
        }
    }
</style>
